"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-47f2d614"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex flex-col lg:flex-row bg-white gap-2 py-2 px-4 mb-4" };
const _hoisted_3 = {
    id: "filter-panel",
    class: "bg-white"
};
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4 p-4" };
const _hoisted_5 = { class: "w-full grid grid-cols-2 gap-4" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("hr", { class: "invisible h-4" }, null, -1));
const _hoisted_7 = {
    id: "rims-panel",
    class: "p-4 bg-white"
};
const _hoisted_8 = {
    key: 0,
    class: "flex rims-row overflow-x-scroll"
};
const _hoisted_9 = {
    key: 0,
    class: "p-2"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "m-auto block w-full text-center font-bold" };
const _hoisted_13 = {
    key: 1,
    class: "flex rims-row"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bg-gray relative w-40 md:w-60 grid place-content-center h-48" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon marso-icon-wheel-3d text-9xl" })
], -1));
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("hr", { class: "invisible h-4" }, null, -1));
const _hoisted_17 = { class: "grid lg:grid-cols-2 lg:gap-4" };
const _hoisted_18 = ["src"];
const _hoisted_19 = {
    key: 1,
    class: "car-image grid place-content-center bg-gray"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon marso-icon-UHP" }, null, -1));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = {
    key: 0,
    class: "bg-gray p-4 relative"
};
const _hoisted_23 = { class: "text-xl" };
const _hoisted_24 = { class: "font-bold" };
const _hoisted_25 = { class: "font-bold text-gray-darker" };
const _hoisted_26 = { class: "text-lg" };
const _hoisted_27 = { class: "font-bold" };
const _hoisted_28 = { class: "text-base" };
const _hoisted_29 = { class: "text-base" };
const _hoisted_30 = { class: "hide-foreign-customer" };
const _hoisted_31 = { class: "font-bold" };
const _hoisted_32 = { class: "text-base text-gray-darker" };
const _hoisted_33 = {
    key: 0,
    class: "text-sm"
};
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "relative marso-icon-recycle text-green tooltip" }, null, -1));
const _hoisted_35 = {
    key: 1,
    class: "text-sm"
};
const _hoisted_36 = { key: 0 };
const _hoisted_37 = { class: "font-bold" };
const _hoisted_38 = { class: "text-base text-gray-darker" };
const _hoisted_39 = { key: 1 };
const _hoisted_40 = { class: "font-bold" };
const _hoisted_41 = { class: "text-base text-gray-darker" };
const _hoisted_42 = {
    key: 0,
    class: "text-sm"
};
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "relative marso-icon-recycle text-green tooltip" }, null, -1));
const _hoisted_44 = {
    key: 1,
    class: "text-sm"
};
const _hoisted_45 = { class: "font-bold" };
const _hoisted_46 = { class: "flex gap-2 grid-cols-2 justify-end items-center mr-0 ml-auto h-12" };
const _hoisted_47 = ["for"];
const _hoisted_48 = ["id"];
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-shopping_cart" }, null, -1));
const _hoisted_50 = [
    _hoisted_49
];
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-wheel-3d" }, null, -1));
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "+", -1));
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon marso-icon-screw-nut-3d" }, null, -1));
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("hr", { class: "invisible h-4" }, null, -1));
const vue_3 = require("vue");
const interfaces_1 = require("../../stores/productRimsByCar/interfaces");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const i18n_1 = require("../../common/i18n");
const ProductPopup_vue_1 = __importDefault(require("../../components/ProductPopup.vue"));
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const shop_1 = require("../../common/utils/shop");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const rimSearchByCarStore_1 = require("../../stores/productRimsByCar/rimSearchByCarStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
const ProductListTable_vue_1 = __importDefault(require("../../components/ProductListTable/ProductListTable.vue"));
const customDesignStore_1 = require("../../stores/customDesign/customDesignStore");
const tagStore_1 = require("../../stores/tag/tagStore");
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductRimsByCar',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const rimSearchStore = (0, rimSearchByCarStore_1.useRimSearchByCarStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const tagStore = (0, tagStore_1.useTagStore)();
        const carForm = (0, vue_3.computed)(() => rimSearchStore.carForm);
        const selectedRim = (0, vue_3.computed)(() => rimSearchStore.selectedRim);
        const isExportCustomer = (0, vue_3.computed)(() => {
            var _a;
            if ((_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.EXPORT_PARTNER)) {
                return true;
            }
            return false;
        });
        const zeroStockSwitch = (0, vue_3.ref)(false);
        const setSwitch = (0, vue_3.ref)(false);
        const retailPriceSwitch = (0, vue_3.ref)(false);
        const grossPriceSwitch = (0, vue_3.ref)(false);
        const pairSearchSwitch = (0, vue_3.ref)(false);
        const customPriceSwitch = (0, vue_3.computed)(() => customDesignStore.isCustomPriceViewActive);
        (0, vue_3.watch)(() => carForm.value.carBrand, () => {
            rimSearchStore.rewindTo(interfaces_1.CarFormStep.Brand);
            rimSearchStore.loadTypes(router);
        });
        (0, vue_3.watch)(() => carForm.value.carType, () => {
            rimSearchStore.rewindTo(interfaces_1.CarFormStep.Type);
            rimSearchStore.loadModels(router);
        });
        (0, vue_3.watch)(() => carForm.value.carModel, () => {
            rimSearchStore.rewindTo(interfaces_1.CarFormStep.Model);
            rimSearchStore.loadRims(router).catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        });
        (0, vue_3.watch)(() => carForm.value.rimSize, () => {
            rimSearchStore.rimSizeChanged();
        });
        (0, vue_3.watch)(() => carForm.value.rimTpms, () => {
            rimSearchStore.rimTpmsChanged();
        });
        const readRimTpmsItemsForSelect = () => {
            let rimTpmss = carForm.value.rimTpmss;
            let keys = Object.keys(rimTpmss);
            keys = keys.filter((key) => {
                if (rimTpmss[key].length) {
                    return true;
                }
                return false;
            });
            return keys;
        };
        const selectRim = (id) => {
            rimSearchStore.selectRim(id);
        };
        const addToCart = (event, id, kitsetId) => {
            var _a;
            let target = event.currentTarget;
            if (id === undefined) {
                return;
            }
            if (!(target instanceof HTMLElement)) {
                return;
            }
            let input = (_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector(".quantity");
            let quantity = 0;
            if (input instanceof HTMLInputElement) {
                quantity = parseInt(input.value ? input.value : "0");
            }
            let kitsetQuantity = 0;
            if (0 < quantity) {
                kitsetQuantity = 1;
            }
            cartsStore
                .addProduct(router, quantity, id)
                .then(() => {
                if (input instanceof HTMLInputElement) {
                    input.value = "";
                }
                if (kitsetId && kitsetQuantity) {
                    cartsStore.addProduct(router, kitsetQuantity, kitsetId);
                }
            })
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        const parseTyreName = (tyreName) => {
            var _a, _b, _c;
            const parsedTyreName = /([0-9]+)\/([0-9]+)R([0-9]+)/i.exec(tyreName);
            if (parsedTyreName === null) {
                return undefined;
            }
            return {
                sizeSlug: [
                    [
                        (_a = parsedTyreName[1]) !== null && _a !== void 0 ? _a : '*',
                        (_b = parsedTyreName[2]) !== null && _b !== void 0 ? _b : '*',
                        (_c = parsedTyreName[3]) !== null && _c !== void 0 ? _c : '*'
                    ].join('~')
                ]
            };
        };
        const tooltipLimited = (0, i18n_1.trans)("product_only_available_on_a_limited_basis_notice", "This product is only available on a limited basis in Marso's national inventory.", "tyre_filter") +
            " " +
            (0, i18n_1.trans)("sales_representative_will_inform_notice", "When ordering, your sales representative will inform you about the availability and delivery time of the product.", "tyre_filter");
        const tooltipOrderable = (0, i18n_1.trans)("product_not_in_stock_notice", "This product is unfortunately not in stock, but can be obtained from the manufacturer.", "tyre_filter") +
            " " +
            (0, i18n_1.trans)("contact_sales_representative_for_product_availability_notice", "Contact your sales representative for product availability and delivery times.", "tyre_filter");
        const tooltipRecycle = (0, i18n_1.trans)("recycle_icon_popup_epr_price", "EPR price", 'search');
        const cssTooltipVars = '--tooltip-orderable: "' +
            tooltipOrderable +
            '"; --tooltip-limited: "' +
            tooltipLimited +
            '"; --tooltip-recycle: "' +
            tooltipRecycle +
            '"';
        (0, vue_3.onMounted)(async () => {
            await rimSearchStore.loadBrands(router)
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.unref)(tagStore).tags.switches.zeroStockSwitch.display)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                            key: 0,
                            modelValue: zeroStockSwitch.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((zeroStockSwitch).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('zero_stock_toggle_label', '0 stock', 'rim_search_by_car'),
                            class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                        }, null, 8, ["modelValue", "label"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(tagStore).tags.switches.setSwitch.display)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                            key: 1,
                            modelValue: setSwitch.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((setSwitch).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('set_toggle_label_set', 'Set', 'rim_search_by_car'),
                            class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                        }, null, 8, ["modelValue", "label"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(tagStore).tags.switches.retailPriceSwitch.display)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                            key: 2,
                            modelValue: retailPriceSwitch.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((retailPriceSwitch).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('retail_price_toggle_label', 'Retail price', 'rim_search_by_car'),
                            class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                        }, null, 8, ["modelValue", "label"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.display)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                            key: 3,
                            modelValue: grossPriceSwitch.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((grossPriceSwitch).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('gross_price_toggle_label_gross', 'Gross', 'rim_search_by_car'),
                            class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                        }, null, 8, ["modelValue", "label"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(tagStore).tags.switches.pairSearchSwitch.display)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                            key: 4,
                            modelValue: pairSearchSwitch.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((pairSearchSwitch).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('pair_search_toggle', 'Pair search', 'rim_search_by_car'),
                            class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                        }, null, 8, ["modelValue", "label"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('car_brand', 'Car brand', 'rim_search_by_car'),
                            items: (0, vue_2.unref)(carForm).carBrands,
                            modelValue: (0, vue_2.unref)(carForm).carBrand,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (((0, vue_2.unref)(carForm).carBrand) = $event)),
                            "disable-deselect": ""
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('car_type', 'Car type', 'rim_search_by_car'),
                            items: (0, vue_2.unref)(carForm).carTypes,
                            modelValue: (0, vue_2.unref)(carForm).carType,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (((0, vue_2.unref)(carForm).carType) = $event)),
                            "disable-deselect": ""
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('car_model', 'Car model', 'rim_search_by_car'),
                            items: (0, vue_2.unref)(carForm).carModels,
                            modelValue: (0, vue_2.unref)(carForm).carModel,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (((0, vue_2.unref)(carForm).carModel) = $event)),
                            "disable-deselect": ""
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('rim_size', 'Rim size', 'rim_search_by_car'),
                                items: Object.keys((0, vue_2.unref)(carForm).rimSizes),
                                modelValue: (0, vue_2.unref)(carForm).rimSize,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (((0, vue_2.unref)(carForm).rimSize) = $event)),
                                "disable-deselect": ""
                            }, null, 8, ["placeholder", "items", "modelValue"]),
                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('rim_tpms', 'Rim TPMS', 'rim_search_by_car'),
                                items: readRimTpmsItemsForSelect(),
                                modelValue: (0, vue_2.unref)(carForm).rimTpms,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (((0, vue_2.unref)(carForm).rimTpms) = $event)),
                                "disable-deselect": ""
                            }, null, 8, ["placeholder", "items", "modelValue"])
                        ])
                    ])
                ]),
                _hoisted_6,
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    ((0, vue_2.unref)(carForm).filteredRims.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(carForm).carRims, (rim) => {
                                var _a;
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, {
                                    key: rim.Article
                                }, [
                                    ((0, vue_2.unref)(carForm).filteredRims.includes(rim.Article))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(["cursor-pointer relative w-40 md:w-60", {
                                                        'shadow-sm': rim.Article ===
                                                            ((_a = (0, vue_2.unref)(selectedRim)) === null || _a === void 0 ? void 0 : _a.manufacturerSku),
                                                    }]),
                                                onClick: ($event) => (selectRim(rim.Article))
                                            }, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: (0, vue_2.normalizeClass)([
                                                        '{{rim.Article == carForm.selectedRim}}'
                                                            ? ''
                                                            : '',
                                                    ])
                                                }, [
                                                    (0, vue_2.createElementVNode)("img", {
                                                        class: "m-auto block",
                                                        src: rim.Image,
                                                        alt: ""
                                                    }, null, 8, _hoisted_11),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)(rim.size), 1)
                                                ], 2)
                                            ], 10, _hoisted_10)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 64));
                            }), 128))
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, _hoisted_15))
                ]),
                _hoisted_16,
                (0, vue_2.createElementVNode)("div", {
                    id: "product-panel",
                    class: "p-4 bg-white",
                    style: cssTooltipVars
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                        (0, vue_2.createElementVNode)("div", null, [
                            ((0, vue_2.unref)(selectedRim) && (0, vue_2.unref)(selectedRim).ImageOnCarBinary)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                    key: 0,
                                    class: "car-image object-cover",
                                    src: (0, vue_2.unref)(selectedRim).ImageOnCarBinary,
                                    alt: ""
                                }, null, 8, _hoisted_18))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, _hoisted_21))
                        ]),
                        ((0, vue_2.unref)(selectedRim))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(selectedRim).Brand), 1),
                                    (0, vue_2.createTextVNode)("  "),
                                    (0, vue_2.createElementVNode)("span", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(selectedRim).treadCode), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(selectedRim).manufacturerSku), 1),
                                    (0, vue_2.createTextVNode)("   "),
                                    (0, vue_2.createElementVNode)("span", _hoisted_28, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("order_sku", "Order SKU", "rim_search_by_car")), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(selectedRim).size), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceListNet, (0, vue_2.unref)(selectedRim).prices.currencyCode, { vatPercent: (0, vue_2.unref)(selectedRim).prices.priceVatPercent })), 1),
                                    (0, vue_2.createTextVNode)("  "),
                                    (0, vue_2.createElementVNode)("span", _hoisted_32, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("list_price", "List price", "rim_search_by_car")), 1),
                                    (0, vue_2.createTextVNode)("  "),
                                    ((0, vue_2.unref)(selectedRim).prices.priceEprNet)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_33, [
                                            (0, vue_2.createTextVNode)(" ( " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceListNet - (0, vue_2.unref)(selectedRim).prices.priceEprNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)) + " + ", 1),
                                            _hoisted_34,
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceEprNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)) + " + " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("vat_list_price", "VAT", "rim_search_by_car")) + " ) ", 1)
                                        ]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_35, " ( " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceListNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)) + " + " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("vat_list_price", "VAT", "rim_search_by_car")) + " ) ", 1))
                                ]),
                                ((0, vue_2.unref)(isExportCustomer))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_36, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_37, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceDiscountNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)), 1),
                                        (0, vue_2.createTextVNode)("  "),
                                        (0, vue_2.createElementVNode)("span", _hoisted_38, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("wholesale_price", "Wholesale price", "rim_search_by_car")), 1)
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_39, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_40, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceDiscountNet, (0, vue_2.unref)(selectedRim).prices.currencyCode, { vatPercent: (0, vue_2.unref)(selectedRim).prices.priceVatPercent })), 1),
                                        (0, vue_2.createTextVNode)("  "),
                                        (0, vue_2.createElementVNode)("span", _hoisted_41, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("wholesale_price", "Wholesale price", "rim_search_by_car")), 1),
                                        (0, vue_2.createTextVNode)("  "),
                                        ((0, vue_2.unref)(selectedRim).prices.priceEprNet)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_42, [
                                                (0, vue_2.createTextVNode)(" ( " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceDiscountNet - (0, vue_2.unref)(selectedRim).prices.priceEprNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)) + " + ", 1),
                                                _hoisted_43,
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceEprNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)) + " +" + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("vat_wholesale_price", "VAT", "rim_search_by_car")) + " ) ", 1)
                                            ]))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_44, " ( " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(selectedRim).prices.priceDiscountNet, (0, vue_2.unref)(selectedRim).prices.currencyCode)) + " + " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("vat_wholesale_price", "VAT", "rim_search_by_car")) + " ) ", 1))
                                    ])),
                                (0, vue_2.createElementVNode)("div", null, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("tyre_size", "Tyre size", "rim_search_by_car")) + ": ", 1),
                                    (0, vue_2.createElementVNode)("ul", null, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedRim).TyreLine, (tyreLine, index) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: index }, [
                                                (0, vue_2.createVNode)(_component_router_link, {
                                                    to: { name: 'shop_passenger_tyres', query: parseTyreName(tyreLine.Tyre) },
                                                    target: "_blank",
                                                    class: "underline text-blue font-bold"
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(tyreLine.Tyre), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"])
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                    (0, vue_2.createElementVNode)("label", {
                                        for: 'quantity-' + (0, vue_2.unref)(selectedRim).id,
                                        class: "h-full font-bold text-center inline-block px-1 bg-white"
                                    }, [
                                        (0, vue_2.createElementVNode)("input", {
                                            id: 'quantity-' + (0, vue_2.unref)(selectedRim).id,
                                            class: "quantity h-full text-center inline-block w-16 mr-2",
                                            type: "number",
                                            min: "0",
                                            max: "100",
                                            placeholder: "0",
                                            onClick: _cache[10] || (_cache[10] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                        }, null, 8, _hoisted_48),
                                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("short_unit", "pc.", "rim_search_by_car")), 1)
                                    ], 8, _hoisted_47),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "add-to-cart btn btn-cart btn-rounded btn-primary text-3xl !px-4 !py-2 !h-12",
                                        onClick: _cache[11] || (_cache[11] = ($event) => { var _a; return (addToCart($event, (_a = (0, vue_2.unref)(selectedRim)) === null || _a === void 0 ? void 0 : _a.id)); })
                                    }, _hoisted_50),
                                    ((0, vue_2.unref)(selectedRim).Kitset)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            type: "button",
                                            class: "add-to-cart btn btn-cart btn-rounded btn-info text-3xl !px-4 !py-2 !h-12",
                                            onClick: _cache[12] || (_cache[12] = ($event) => { var _a, _b, _c; return (addToCart($event, (_a = (0, vue_2.unref)(selectedRim)) === null || _a === void 0 ? void 0 : _a.id, (_c = (_b = (0, vue_2.unref)(selectedRim)) === null || _b === void 0 ? void 0 : _b.kitsetProduct) === null || _c === void 0 ? void 0 : _c.id)); })
                                        }, [
                                            _hoisted_51,
                                            _hoisted_52,
                                            _hoisted_53,
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('kitset_button_label', 'KITSET', 'rim_search_by_car')), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                _hoisted_54,
                (0, vue_2.createVNode)(ProductListTable_vue_1.default, {
                    products: (_b = (_a = (0, vue_2.unref)(selectedRim)) === null || _a === void 0 ? void 0 : _a.valves) !== null && _b !== void 0 ? _b : [],
                    switches: {
                        zeroStockSwitch: zeroStockSwitch.value,
                        setSwitch: setSwitch.value,
                        retailPriceSwitch: retailPriceSwitch.value,
                        grossPriceSwitch: grossPriceSwitch.value,
                        pairSearchSwitch: pairSearchSwitch.value,
                        customPriceSwitch: (0, vue_2.unref)(customPriceSwitch)
                    },
                    "table-name": (0, vue_2.unref)(i18n_1.trans)('related_valves_for_the_currently_searched_rim', 'Related valves for the currently selected rim', 'rim_search_by_car'),
                    "disabled-columns": {
                        size: true
                    }
                }, null, 8, ["products", "switches", "table-name"]),
                (0, vue_2.createVNode)(ProductListTable_vue_1.default, {
                    products: (_c = (0, vue_2.unref)(carForm).carRims.filter((rim) => (0, vue_2.unref)(carForm).filteredRims.includes(rim.Article))) !== null && _c !== void 0 ? _c : [],
                    switches: {
                        zeroStockSwitch: zeroStockSwitch.value,
                        setSwitch: setSwitch.value,
                        retailPriceSwitch: retailPriceSwitch.value,
                        grossPriceSwitch: grossPriceSwitch.value,
                        pairSearchSwitch: pairSearchSwitch.value,
                        customPriceSwitch: (0, vue_2.unref)(customPriceSwitch)
                    },
                    "table-name": (0, vue_2.unref)(i18n_1.trans)('filtered_rims', 'Filtered rims', 'rim_search_by_car'),
                    "disabled-columns": {
                        id: true
                    }
                }, null, 8, ["products", "switches", "table-name"]),
                (0, vue_2.createVNode)(ProductPopup_vue_1.default)
            ]));
        };
    }
});
